import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import {
  Button,
  Grid,
  Icon,
  Label,
  Message,
} from 'semantic-ui-react';
import { Trans, withTranslation } from 'react-i18next';

import { fetchM } from '../../actions/fetchM';
import Countdown from '../../components/Countdown';
import Phone from '../../components/Phone';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class ConsentPin extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    errMessage: PropTypes.string,
    getStarted: PropTypes.func.isRequired,
    isError: PropTypes.bool,
    mobile: PropTypes.string,
    mobilePrefix: PropTypes.string,
    onClose: PropTypes.func,
    onErrDismiss: PropTypes.func.isRequired,
    onPinRequestableChange: PropTypes.func,
    setLoading: PropTypes.func.isRequired,
  }
  constructor(props) {
    super(props);
    this.state = {
      mobilePrefix: 'XXX',
      mobile: 'XXXXXXX',
      pinRequestable: true,
      token: null,
      data: null,
      message: null,
      consentPin: '',
      agreedToTerms: false,
    };
  }
  componentDidMount() {
    this.getDropLead();
  }
  componentWillUnmount() {
    this.countdown.stopTimer();
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading = (loading = false) => {
    if (this.props.setLoading) {
      return this.props.setLoading(loading);
    }
    return Promise.resolve();
  }
  async getDropLead() {
    await this.setLoading(true);
    await this.fetchDropLead();
    const { data, pinRequestable } = this.state;
    if (data.developerProject && data.developerProject.consentTypeID === 2 &&
        data.updatedAt && pinRequestable) {
      this.startTimer(data.updatedAt, data.consentPinCount);
    }
    await this.setLoading(false);
  }
  async fetchDropLead() {
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/loan_trackers/draft/`, {
        credentials: 'include',
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await this.setComponentState({
        message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }),
      });
      return false;
    }
    if (!res.ok) {
      const message = await res.text();
      await this.setComponentState({
        message,
      });
      return false;
    }
    const token = res.headers.get('X-Csrf-Token');
    const data = await res.json();
    await this.setComponentState({
      token,
      data,
      message: null,
    });
    return true;
  }
  async fetchNewPin(data = {}) {
    await this.setLoading(true);
    const dataResp = await this.props.getStarted(data);
    if (dataResp && dataResp.id > 0) {
      return;
    }
    await this.getDropLead();
    await this.setLoading(false);
  }
  submitable(type) {
    switch (type) {
      case 'drop':
        return !this.state.pinRequestable;
      case 'create':
        return this.state.agreedToTerms && this.state.consentPin;
      default:
        return false;
    }
  }
  startTimer = (timeAt, count = 1) => {
    let time = 30 * count;
    const update = moment(timeAt);
    const seconds = moment().diff(update, 'seconds');
    if (seconds <= time) {
      time -= seconds;
    } else {
      time = 0;
    }
    this.countdown.startTimer(time);
  }
  countdownMessage = (time) => {
    const data = this.state.data || {};
    const { t } = this.props;
    if (data.pinExpiresAt &&
      moment().isAfter(moment(data.pinExpiresAt))) {
      return (
        <div>
          <p className="message">{t('PIN expired')}.&nbsp;
            <a
              href=""
              onClick={this.handleCreateDrop}
            >
              {t('Request new PIN now')}.
            </a>
          </p>
        </div>
      );
    } else if (time >= 0) {
      let message = 'in {{time}} seconds';
      if (time === 1) {
        message = 'in {{time}} second';
      }
      if (time < 1) {
        message = 'now';
      }
      return (
        <div>
          <p className="message" style={{ textAlign: 'center', margin: '0.5em' }}>
            {t('Trouble receiving PIN?')} {time < 1 ? (
              <a
                href=""
                onClick={this.handleCreateDrop}
              >
                {t('Request new PIN now')}
              </a>
            ) : t(`Request new PIN ${message}`, { time: time })}.</p>
        </div>
      );
    }
    return null;
  }
  handleCreateDrop = (event) => {
    event.preventDefault();
    this.fetchNewPin();
  }
  handleSetPinRequestable = (pr) => {
    this.setState({ pinRequestable: pr }, () => {
      this.props.onPinRequestableChange(pr);
    });
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      consentPin: this.state.consentPin,
      agreedToTerms: this.state.agreedToTerms,
    };
    this.fetchNewPin(data);
  }
  render() {
    const { mobile, mobilePrefix, t } = this.props;
    return (
      <div>
        <div className="row">
          <div className="center aligned sixteen wide column">
            {
              this.props.isError ? (
                <Message
                  error
                  onDismiss={() => {
                    this.props.onErrDismiss();
                  }}
                  content={this.props.errMessage}
                />
              ) : null
            }
          </div>
        </div>
        <form className="ui form" onSubmit={this.handleSubmit}>
          <Grid>
            <Grid.Row className="consent-pin-message">
              <Grid.Column>
                <Label>
                  <Icon name="check circle" color="green" />
                  {t('Consent PIN has been sent to your buyer\'s mobile number')}&nbsp;
                  <Phone
                    mobilePrefix={mobilePrefix || 'XXX'}
                    mobile={mobile || 'XXXXXXX'}
                  />. {t('Please enter the PIN they shared to you')}.
                </Label>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <div className="ui fluid input">
            <input
              style={{
                maxWidth: '20em',
                margin: 'auto',
              }}
              type="tel"
              name="consentPin"
              placeholder={t('6 digit PIN')}
              onChange={(e) => {
                this.setState({ consentPin: e.target.value });
              }}
              ref={(ref) => { this.consentPin = ref; }}
            />
          </div>
          <div className="ui checkbox">
            <input
              type="checkbox"
              name="agreedToTerms"
              id="agreedToTerms"
              onChange={(e) => {
                this.setState({ agreedToTerms: e.target.checked });
              }}
              ref={(ref) => { this.agreedToTerms = ref; }}
              checked={this.state.agreedToTerms}
            />
            <div className="helper">
              <Countdown
                ref={(ref) => { this.countdown = ref; }}
                message={this.countdownMessage}
                onStart={() => this.handleSetPinRequestable(false)}
                onComplete={() => this.handleSetPinRequestable(true)}
              />
            </div>
            <label className="terms" htmlFor="agreedToTerms">
              <Trans ns={TRANSLATION_FILES.screens}>
                I agree to the terms and conditions
                set out in the&nbsp;
                <a
                  href="https://mhub.my/policies/trial_service_agreement/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Agreement for Affiliates
                </a>
                &nbsp;for Loan Referrals
              </Trans>
            </label>
          </div>
          <div className="consent-actions">
            <Button
              className="cancel"
              content={t('Cancel', { ns: TRANSLATION_FILES.translation })}
              onClick={() => this.props.onClose()}
            />
            <Button
              className="done"
              content={t('Done')}
              color="blue"
              disabled={!this.submitable('create')}
            />
          </div>
        </form>
      </div>
    );
  }
}

export default withTranslation(namespaces)(ConsentPin);



// WEBPACK FOOTER //
// ./src/containers/LoanTracker/ConsentPin.jsx